export enum HttpStatus {
  OK = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  NotFound = 404,
  UnprocessableContent = 422,
  InternalServerError = 500,
  BadGateway = 502,
  ServiceUnavailable = 503,
}
export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
}
export enum HttpHeader {
  ContentType = 'Content-Type',
}
export enum ContentType {
  JSON = 'application/json',
}
export enum ApiEndpoint {
  CuratedQuery = 'curated-query',
  Topics = 'active-topics',
  Feedback = 'feedbacks',
  PDFDetails = 'pdf-viewer',
  QueryLogs = 'query-logs',
  QueryLogsBulkDelete = 'query-logs/bulk-delete',
}
